import { forwardRef } from 'react';
import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';

const StyledSection = styled.section`
    width: 100%;
    padding: 0px;
    margin-top: ${themeGet('margin.large')};
    height: calc(100% - ${themeGet('margin.large')});
    display: flex;
    flex-direction: column;
`;

const Title = styled.h2`
    padding-left 16px;
    margin-bottom: ${themeGet('margin.standard')};
    font-size: ${themeGet('font.title')};
    font-weight: 700;
`;

const Section = forwardRef(({ children, title, className, style }, ref) => {
    return (
        <StyledSection ref={ref} className={className} style={style}>
            {title && <Title>{title}</Title>}
            {children}
        </StyledSection>
    );
});

export default Section;
